/* eslint-disable react/no-danger */
import React from 'react';
import PropTypes from 'prop-types';
import useStyles from 'isomorphic-style-loader/useStyles';
import ShowMore from 'components/ShowMore';

// assets
import CssEditorialBlurb from './EditorialBlurb.scss';

function EditorialBlurb(props) {
  const { ckbkBlurb, publisherBlurb } = props;
  useStyles(CssEditorialBlurb);

  const formatBlurb = blurb => {
    if (!blurb || typeof blurb != 'string') {
      return '';
    }

    return `<p>${blurb.replace(/\n\n/g, '</p><p>').replace(/\n/g, '<br/>')}</p>`;
  };

  return (
    <div className="editorial-blurbs">
      {ckbkBlurb ? (
        <div className="editorial-blurbs__item">
          <header className="editorial-blurbs__header">
            <img src="images/logo.png" className="editorial-blurbs__logo" alt="Logo" />
            <p className="editorial-blurbs__ckbk">says</p>
          </header>
          <div
            className="editorial-blurbs__blurb"
            dangerouslySetInnerHTML={{
              __html: formatBlurb(ckbkBlurb),
            }}
          />
        </div>
      ) : null}
      {publisherBlurb ? (
        <div className="editorial-blurbs__item">
          <header className="editorial-blurbs__header">
            <p className="editorial-blurbs__publisher">from the publisher</p>
          </header>
          <ShowMore
            withFormatting={false}
            childrenLength={publisherBlurb.length}
            backgroundColor="alabaster"
          >
            <div
              className="editorial-blurbs__blurb"
              dangerouslySetInnerHTML={{
                __html: formatBlurb(publisherBlurb),
              }}
            />
          </ShowMore>
        </div>
      ) : null}
    </div>
  );
}

EditorialBlurb.propTypes = {
  publisherBlurb: PropTypes.string,
  ckbkBlurb: PropTypes.string,
};

EditorialBlurb.defaultProps = {
  publisherBlurb: '',
  ckbkBlurb: '',
};

export default React.memo(EditorialBlurb);
